import React from 'react';
import { Globe2 } from 'lucide-react';

/**
 * Listede olan ama yayına alınmamış giriş adresinde portalın yerine çizilen
 * ekran (Operasyon → Giriş Adresleri).
 *
 * Kural: bir adres **Yayına al** yapılmadan siteyi açmaz. Yayında başka bir
 * adres varsa ziyaretçi oraya taşınır ve bu ekran hiç görünmez; görünüyorsa
 * yayında hiç adres yoktur. Panel (`/admin`) bu kuraldan muaftır.
 *
 * `closed`: adres panelden kapatıldı (Sunucudan kaldır / Sil). Ziyaretçi
 * yayındaki adrese taşınmaz; ekran adresin artık kullanılmadığını söyler.
 */
const EntryInactiveScreen = ({ closed = false }) => (
  <div className="fixed inset-0 z-[9999] overflow-y-auto bg-[var(--pusu-bg-deep)]">
    <main className="min-h-full grid place-items-center px-4 py-10">
      <section className="pusu-panel w-full max-w-lg p-8 text-center" role="status">
        <Globe2 size={32} className="mx-auto mb-4 text-[var(--pusu-accent-light)]" aria-hidden="true" />
        <h1 className="text-xl font-bold text-[var(--pusu-text)]">
          {closed ? 'Bu adres artık kullanılmıyor' : 'Bu adres henüz yayında değil'}
        </h1>
        <p className="mt-3 text-sm leading-relaxed text-[var(--pusu-text-muted)]">
          Güncel giriş adresimizi resmi sosyal medya hesaplarımızdan ya da canlı
          destekten öğrenebilirsiniz.
        </p>
      </section>
    </main>
  </div>
);

export default EntryInactiveScreen;
